{
  "partnership_invitations": {
    "navigation_title": "Invitations",
    "title": "Partnership Invitations",
    "invite_new_partner": "Invite Partner",
    "address_label": "Contact Email",
    "address_placeholder": "manager email or organization id",
    "invalid_address": "Organization addressing unknown.",
    "organization_from_email_not_unique": "Organization could not be identified from the email address",
    "invite_button": "Send Invitation",
    "inviting_org_label": "Inviting Organization",
    "empty_list": "No partnership invitations"
  }
}
